const TURKISH_CHAR_MAP: Record<string, string> = {
  ç: "c",
  ğ: "g",
  ı: "i",
  ö: "o",
  ş: "s",
  ü: "u",
};

/**
 * Lowercases with Turkish rules and folds Turkish/diacritic characters so that
 * e.g. "universitesi" matches "Üniversitesi" and "ISIK" matches "Işık".
 */
export function normalizeSearchText(value: string): string {
  return (value || "")
    .toLocaleLowerCase("tr")
    .replace(/[çğıöşü]/g, (char) => TURKISH_CHAR_MAP[char])
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();
}

/**
 * Filters companies by title. Every word of the query must appear in the
 * company title, so "ankara uni" matches "Ankara Üniversitesi".
 */
export function filterCompaniesByTitle<T extends { title?: string }>(
  companies: T[],
  query: string,
): T[] {
  const terms = normalizeSearchText(query).split(/\s+/).filter(Boolean);
  if (!terms.length) return companies;

  return companies.filter((company) => {
    const title = normalizeSearchText(company.title || "");
    return terms.every((term) => title.includes(term));
  });
}
